import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.671 8.62a5.306 5.306 0 0 1-7.177 4.963.75.75 0 1 1 .53-1.4 3.8 3.8 0 1 0 1.713-7.329v.729a.5.5 0 0 1-.286.452.491.491 0 0 1-.214.048.5.5 0 0 1-.318-.113l-1.83-1.5a.5.5 0 0 1 0-.773l1.83-1.5a.5.5 0 0 1 .818.387v.778a5.3 5.3 0 0 1 4.934 5.258Zm-7.48 2.98a.748.748 0 0 1-1.06 0L2.548 9.02a.751.751 0 0 1 0-1.06l2.583-2.582a.749.749 0 0 1 1.06 0L8.773 7.96a.749.749 0 0 1 0 1.06Zm-.53-1.591L7.183 8.49 5.661 6.969 4.139 8.49Z';
const draw24px =
  'M21.79,13.142a8.707,8.707,0,0,1-11.777,8.144.75.75,0,0,1,.53-1.4A7.2,7.2,0,1,0,13.22,5.947l1.986,1.631a.75.75,0,1,1-.952,1.159l-3.2-2.626a.75.75,0,0,1,0-1.159l3.2-2.626a.75.75,0,0,1,.952,1.159l-1.219,1A8.714,8.714,0,0,1,21.79,13.142Zm-7.071-.231L9.1,18.525a.748.748,0,0,1-1.06,0L2.43,12.911a.749.749,0,0,1,0-1.06L8.044,6.236a.749.749,0,0,1,1.06,0l5.615,5.615A.749.749,0,0,1,14.719,12.911Zm-1.591-.53L8.574,7.827,4.02,12.381l4.554,4.554Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const RotatePageIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'rotatePage'),
) as IconWithRender;

RotatePageIcon.displayName = 'RotatePageIcon';
RotatePageIcon.propTypes = Icon.propTypes;
RotatePageIcon.renderIcon = (props) => <RotatePageIcon {...props} />;
export default RotatePageIcon;
